import httpService from "../../services/http.service";
import axios from "axios";
import Config from "../../config.json"

class CatalystService{
    LogOut(projectId) {

        axios.get("https://catly-795086611.catalystserverless.com/baas/logout?logout=true&PROJECT_ID="+projectId)
        .then((result)=>{
           
        })
        .catch((err)=>{
            console.log(err);
        })
    
    }

    GetLoggedUser(project_id) {
        return new Promise((resolve, reject) => {
            let config = {
                Type: 'Get',
                method: 'GET',
                url: "https://api.catalyst.zoho.com/baas/v1/project/"+project_id+"/project-user/current",
                headers: { "Authorization": localStorage.getItem('token') },
                data: {}
            }
            axios.post(Config.backend_aws_server_url+'zoho/workdrive', config)
                .then((result) => {
                    resolve(result.data);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    
    
    }
    saveUserToken (data) {
        return new Promise((resolve, reject) => {
            axios.post(Config.backend_aws_server_url +`OAuthTokens/saveUserToken`,{data:data}).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
    updateUserToken (data) {
        return new Promise((resolve, reject) => {
            axios.put(Config.backend_aws_server_url +`OAuthTokens/updateUserToken`,{data:data}).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }

}

export default new CatalystService();